import { authentication } from '@perpay-web/authentication/singleton';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    passkeyAuthenticateComplete,
    passkeyAuthenticateCompleteSuccess,
    passkeyAuthenticateCompleteError,
    passkeyAuthenticateCompleteReset,
} from '@perpay-web/fintech/actions/passkey';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const usePasskeyAuthenticateCompleteDataModule = () => {
    const dataModule = useDataModule((payload) =>
        authentication.authenticatePasskey(payload),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: passkeyAuthenticateComplete,
        success: passkeyAuthenticateCompleteSuccess,
        error: passkeyAuthenticateCompleteError,
        reset: passkeyAuthenticateCompleteReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = usePasskeyAuthenticateCompleteDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UsePasskeyAuthenticateCompleteDataModuleProvider,
    usePasskeyAuthenticateCompleteContext,
] = createContextProvider(providerFactory);
